import { render, staticRenderFns } from "./UtilIframe.vue?vue&type=template&id=7c935cc4&scoped=true&"
import script from "./UtilIframe.vue?vue&type=script&lang=js&"
export * from "./UtilIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c935cc4",
  null
  
)

export default component.exports